import React from 'react';
import CommonLayout from '../layouts/CommonLayout';
import useAuthStore from '../../store/authStore';


const BannedPage = () => {
    const { logout } = useAuthStore();

    const handleLogout = () => {
        logout();
    };

    return (
        <CommonLayout title="계정 정지 안내" showBackButton={false}>
            <div className="flex flex-col items-center justify-center h-full">
                <h1 className="text-2xl font-bold">고객님의 계정은 운영 정책 위반으로 인해 정지되었습니다.</h1>
                <button onClick={handleLogout} className="mt-4 px-4 py-2 bg-gray-500 text-white rounded-md">로그아웃</button>
            </div>
        </CommonLayout>
    );
};

export default BannedPage;  